import React from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import I18n from '../../resources/i18n/I18n'

const ModalEdition = ({ showModal, toggleModal, editLabel, modifyItemLabel, item, title }) => {
  const handleEdit = () => {
    toggleModal()
    editLabel()
  }

  return (
    <Modal show={showModal} onHide={toggleModal}>
      <Modal.Header closeButton>
        <Modal.Title>{title ? title : I18n.t('EditConfirmTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>{I18n.t('Label')}</Form.Label>
          <Form.Control defaultValue={item ? item.label : ''} onChange={(e) => modifyItemLabel(e.target.value)} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-back" onClick={toggleModal}>
          {I18n.t('ModalConfirmCancel')}
        </Button>
        <Button className="primary" onClick={handleEdit}>
          {I18n.t('ModalConfirmOk')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalEdition
